//import _ from 'lodash';
import { connect } from 'react-redux';
import _ from 'lodash';
import Orders from '../components/orders/Orders';
import { IApplicationState } from '@store';
import { Order } from '@models';

interface IMapStateToProps extends Pick<IApplicationState, 'orders'> {}

type OwnProps = {
  orders: Order[];
};

const mapStateToProps = ({ orders }: IMapStateToProps): OwnProps => {
  return {
    orders: orders.orders.map((order) => _.omit(order, 'samples')),
  };
};

export default connect(mapStateToProps)(Orders);
